import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './Modals';
import { ModalStackState } from './redux/types';
import { getModals } from './redux/selectors';
import { popModal } from './redux/actionCreators';
import { getCurrentUser } from '../publicSession/selectors';
import { takeLast } from '../utils/fp';
import { createSelector } from 'reselect';

type StateProps = Pick<Props, 'currentUser'>;
type DispatchProps = Pick<Props, 'popModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const getLastModals = createSelector(getModals, modals => {
  return takeLast(ARBITRARY_MODAL_LIMIT, modals);
});

/** 2 for now to support a modal + a confirmation modal on top */
const ARBITRARY_MODAL_LIMIT = 2;
export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  ModalStackState
> = state => ({
  modals: getLastModals(state), // takeLast(ARBITRARY_MODAL_LIMIT, getModals(state)),
  currentUser: getCurrentUser(state),
});
export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  popModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
